import { RequestFeedbackMessages } from '../../../hooks/useClient';

export const getToastMessages = (isEditing: boolean): RequestFeedbackMessages => {
  return {
    successMessage: {
      summary: isEditing ? 'Rutina modificada' : 'Rutina creada',
      detail: isEditing ? 'La rutina se ha modificado correctamente' : 'Se ha creado la nueva rutina',
    },
    errorMessages: {
      summary: isEditing ? 'Error modificando la rutina' : 'Error al crear la rutina',
      defaultDetail: isEditing ? 'No se ha podido modificar la rutina' : 'No se ha podido crear la rutina',
      RESOURCE_WITH_SAME_NAME_EXISTS: 'Ya existe una plantilla de rutina con ese nombre',
    },
  };
};
